<template>
  <div class="role-change"
       ref="role_child"
       :class="{'role-change--active': isDropDown}"
       v-on-clickaway="setDropdownFromClick">
    <div v-if="isDropDown" class="role-change__dropdown__container">
      <transition name="d-dropdown">
        <div class="role-change__dropdown" v-if="isDropdownPopperDone">
          <ul>
            <li v-for="role in roles" @click.stop="setRole(role)">
              {{ role.v_title }}
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import {createPopper} from '@popperjs/core'
import {mixin as clickaway} from 'vue-clickaway'
import eventbus from '../../eventbus'

export default {
  mixins: [clickaway],
  props: {
    roles: {
      type: Array
    }
  },
  data () {
    return {
      isDropDown: false,
      isDropdownPopperDone: false,
      activeDiv: null
    }
  },
  computed: {
    activeChangeRoleId () {
      return eventbus.activeChangeRoleId
    }
  },
  watch: {
    activeChangeRoleId (val) {
      if (val) {
        this.isDropdownPopperDone = false
        this.activeDiv = document.querySelector('.role-change__selector__placeholder[data-user-id="' + val + '"]')
        this.isDropDown = true
        setTimeout(_ => {
          this.createPopper()
          this.isDropdownPopperDone = true
        }, 0)
      } else {
        eventbus.activeChangeRoleId = null
        this.isDropDown = false
        this.isDropdownPopperDone = false
      }
    }
  },
  methods: {
    createPopper () {
      createPopper(this.activeDiv, this.$refs.role_child, {
        placement: 'bottom-start',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 5]
            }
          }
        ]
      })
    },
    setRole (role) {
      this.$emit('set', role)
      this.isDropDown = false
    },
    setDropdown () {
      if (this.isDropDown) {
        eventbus.activeChangeRoleId = null
        this.isDropDown = false
        this.isDropdownPopperDone = false
      } else {
        this.isDropDown = true
        setTimeout(_ => {
          this.createPopper()
          this.isDropdownPopperDone = true
        }, 0)
      }
    },
    setDropdownFromClick (el) {
      if (!this.isDropDown) {
        return
      }
      this.setDropdown()
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.role-change {
  position: relative;
}

.role-change__selector {
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: #f6f7f8;
  background-repeat: no-repeat;
  background-position: 100% 50%;
  background-size: 16px auto;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAALCAYAAAFpFr+XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAWdJREFUeNpi6OzsjAFihv///4MxEwMDwxIg/s8ABQABxAiSBYGysjIwzcSABgACCKYCpIURRANVMiIrAAggkIIQIL0Gyj8MVGCLrIAFiGcAMTcQzwdiQ3QrQApEgPgdEOsC8VV0BQABBLLiJpBWA+IEIF6IJPcPJI/uJnQA8pU61AN9UM/8g9L6UHG8gBEUepQAgAACeeEwkLbFIgcKPQ6gF5YQ8oINEP9BE08B4tVAXEfIBUzQoGdGMiQLiGcD8Wto4OIFoGi6AMRGQHwOaggzVLMYMWEAS1vngdgEqvkVsZqpEgsAAQaKhQ9Amh+I/wJxMlpiwgYSoWEEcu1HYCwJUOIAUBA4APEbqIELoOEYj0VtGjSRzoOqfQPVy0CpA0CRKAqNyHdYHJIDtXgmNGe8huYSUaheigALEhuUEIShDtkDxIJQh8AAKHE4YSsQKA0BdABKzkLQVPkQiG8DsTYQi1PbchAAAECQW0YytHmoAAAAAElFTkSuQmCC);
  border: 1px solid #d8d8d8;
  height: 28px;
  line-height: 100%;
  padding: 0 24px 0 8px;
  color: #3d4340;
  transition: border-color 0.15s;
}

.role-change__selector:hover {
  border-color: var(--blue);
}

.role-change--active .role-change__selector {
  border-color: var(--blue);
}

.role-change__dropdown__container {
  z-index: 1212;
}

.role-change__dropdown {
  background-color: #fff;
  border-radius: 0;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .24);
  height: auto;
  outline: none;
  text-align: left;
  padding: 0.5rem;
  min-width: 100px;
  user-select: none;
}

.role-change__dropdown > ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.role-change__dropdown > ul > li {
  cursor: pointer;
  font-size: 13px;
  line-height: 18px;
  padding: 0.5rem;
  font-weight: normal;
}

.role-change__dropdown > ul > li:hover {
  background-color: #f5f6f7;
  border-radius: 6px;
}

</style>



// WEBPACK FOOTER //
// PermissionsUserChange.vue?5aa4e423